import GridViewIcon from "@mui/icons-material/GridView";
import StyleIcon from "@mui/icons-material/Style";
import Box from "@mui/material/Box";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Typography from "@mui/material/Typography";
import { menuColors } from "../theme/menuTheme";
import { ViewMode } from "../helpers/types";

const ViewModeToggle = ({
  viewMode,
  setViewMode,
  fullWidth = false
}: {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
  fullWidth?: boolean;
}) => (
  <ToggleButtonGroup
    exclusive
    fullWidth={fullWidth}
    value={viewMode}
    onChange={(_, value: ViewMode | null) => value && setViewMode(value)}
    aria-label="View mode"
    sx={{
      "& .MuiToggleButton-root": {
        color: menuColors.textMuted,
        borderColor: menuColors.border,
        textTransform: "none",
        gap: 1,
        "&.Mui-selected": {
          color: menuColors.text,
          backgroundColor: menuColors.surfaceRaised
        }
      }
    }}>
    <ToggleButton value="study">
      <StyleIcon fontSize="small" />
      Study
    </ToggleButton>
    <ToggleButton value="grid">
      <GridViewIcon fontSize="small" />
      Grid
    </ToggleButton>
  </ToggleButtonGroup>
);

export const ViewModeSection = ({
  viewMode,
  setViewMode
}: {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
}) => (
  <Box sx={{ mb: 2 }}>
    <Typography variant="body2" sx={{ mb: 1, color: menuColors.textMuted, textAlign: "left" }}>
      View mode
    </Typography>
    <ViewModeToggle viewMode={viewMode} setViewMode={setViewMode} fullWidth />
    <Typography variant="caption" sx={{ display: "block", mt: 1, color: menuColors.textMuted, textAlign: "left" }}>
      Grid shows many small character-only tiles. Tap a tile to flip it.
    </Typography>
  </Box>
);

export default ViewModeToggle;
